import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from 'views/components';

const ConfirmDialog = (props) => {
  const {open, title, message, onCancel, onConfirm, confirmText, cancelText, isLoading} = props;

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary" disabled={isLoading}>
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color="primary" disabled={isLoading} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ConfirmDialog;
